module.exports = __webpack_public_path__ + "static/media/tw.5edd886e.svg";